"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CheckOutline_1 = __importDefault(require("../icons/generated/CheckOutline"));
var RemoveOutline_1 = __importDefault(require("../icons/generated/RemoveOutline"));
var checkbox_style_component_1 = require("./checkbox.style.component");
function getCheckmarkBorderColor(color, behaviour) {
    if (behaviour.disabled) {
        return color.disabledColor;
    }
    return behaviour.state === 'unchecked' ? color.color : color.backgroundColor;
}
exports.getCheckmarkBorderColor = getCheckmarkBorderColor;
function getCheckmarkBackgroundColor(color, behaviour) {
    var state = behaviour.state, disabled = behaviour.disabled;
    var disabledColor = color.disabledColor, backgroundColor = color.backgroundColor;
    if (state === 'checked' || state === 'indeterminate')
        return disabled ? disabledColor : backgroundColor;
    return 'transparent';
}
exports.getCheckmarkBackgroundColor = getCheckmarkBackgroundColor;
var Checkbox = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, testID = _a.testID, icon = _a.icon, accentIconColor = _a.accentIconColor;
    return (react_1.default.createElement(checkbox_style_component_1.CheckboxContainer, null,
        react_1.default.createElement(checkbox_style_component_1.CheckMark, { onClick: onChange, state: value, disabled: disabled, "data-test-id": testID },
            value === 'checked' && react_1.default.createElement(CheckOutline_1.default, { "data-test-id": "check-icon" }),
            value === 'indeterminate' && react_1.default.createElement(RemoveOutline_1.default, null)),
        react_1.default.createElement(checkbox_style_component_1.Label, { onClick: onChange, disabled: disabled, accentIconColor: accentIconColor },
            icon && react_1.default.createElement(checkbox_style_component_1.CheckboxIcon, null, icon),
            label)));
};
Checkbox.displayName = 'Checkbox';
exports.default = Checkbox;
//# sourceMappingURL=checkbox.component.js.map